module.exports = __webpack_public_path__ + "img/20190906155327175.93172b23.jpg";